const initialState = {
    status: 'IDLE',
    category: null,
    isUploading: false,
    failedToUpload: false,
    error: null,
};

const queueReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'UPDATE_QUEUE_STATUS':
            return {
                ...state,
                status: action.payload.status,
                isUploading: action.payload.status === 'PROCESSING',
                category: action.payload.category || null,
                error: action.payload.error || null,
                failedToUpload: action.payload.status === 'ERROR', // Set this based on the status
            };
        case 'TOGGLE_IS_UPLOADING':
            return {
                ...state,
                isUploading: action.payload,
            };
        case 'CLEAR_QUEUE_ERROR':
            return {
                ...state,
                error: null,
            };
        case 'UPDATE_QUEUE_CATEGORY':
            return {
                ...state,
                category: action.payload,
            };
        default:
            return state;
    }
};

export default queueReducer;